import styled from 'styled-components';
import { DEVICES, pickThemeColor, pickThemeFontStyles } from '@/theme';
import { Form, FormItem } from '@/components';
import { Button, Input } from '@/ui';

export const StyledForm = styled(Form)`
  display: flex;
  flex-direction: column;
  flex-grow: 1;

  @media screen and ${DEVICES.LAPTOP_S} {
    background-color: transparent;
    padding: 0;
    gap: 1rem;
  }
`;

export const StyledFormBlockWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1rem;

  @media screen and ${DEVICES.LAPTOP_S} {
    padding: 0;
  }
`;

export const StyledDateBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  flex: 1;
  padding: 1rem;
  background-color: ${pickThemeColor('BEIGE')};
  border-radius: 0.25rem;

  @media screen and ${DEVICES.LAPTOP_S} {
    gap: 1rem;
  }
`;

export const StyledRow = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  flex-direction: column;
  gap: 0.5rem;

  @media screen and ${DEVICES.LAPTOP_S} {
    flex-direction: row;
    align-items: center;
    gap: 1rem;
  }
`;

export const StyledDivider = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${pickThemeColor('LIGHT_PURPLE')};
`;

export const StyledDatesWrap = styled.div`
  display: flex;
  width: 100%;
  gap: 1rem;
  flex-direction: column;

  @media screen and ${DEVICES.LAPTOP_S} {
    flex-direction: row;
  }
`;
export const StyledInput = styled(Input)`
  width: 100%;
  max-width: 30rem;
`;

export const StyledDateBlockTitle = styled.div`
  color: ${pickThemeColor('DARK_PURPLE')};
  ${pickThemeFontStyles('14', '22', 'BOLD')};

  @media screen and ${DEVICES.LAPTOP_S} {
    text-align: center;
    ${pickThemeFontStyles('16', '26', 'BOLD')};
  }
`;

export const StyledSecondaryTitle = styled.div`
  color: ${pickThemeColor('DARK_PURPLE')};
  ${pickThemeFontStyles('16', '26', 'SEMI_BOLD')};

  @media screen and ${DEVICES.LAPTOP_S} {
    ${pickThemeFontStyles('28', '32', 'SEMI_BOLD')};
  }
`;

export const StyledFormItem = styled(FormItem)`
  &&& {
    margin: 0;

    label {
      ${pickThemeFontStyles('14', '20')};
      color: ${pickThemeColor('BLACK_PRIMARY')};
    }

    .ant-form-item-control {
      width: 100%;
    }
    .ant-form-item-label {
      padding: 0;
    }
    .ant-form-item-row {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
    }
  }
`;

export const StyledTitle = styled.h1`
  ${pickThemeFontStyles('26', '28', 'SEMI_BOLD')};
  text-align: center;
  margin: 0;
  color: ${pickThemeColor('DARK_PURPLE')};

  @media screen and ${DEVICES.LAPTOP_S} {
    ${pickThemeFontStyles('40', '48', 'SEMI_BOLD')};
    text-align: left;
  }
`;

export const StyledImageHolder = styled.div`
  position: relative;
  min-width: 17rem;
  min-height: 17rem;

  img {
    object-fit: contain;
  }

  @media screen and ${DEVICES.LAPTOP_S} {
    min-width: 27rem;
    min-height: 27rem;
  }
`;

export const StyledButton = styled(Button)`
  &&& {
    z-index: 40;
    width: 100%;

    @media screen and ${DEVICES.LAPTOP_S} {
      width: 13.185rem;
    }
  }
`;

export const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 0 1rem;

  @media screen and ${DEVICES.LAPTOP_S} {
    flex-direction: row;
    border-bottom: 1px solid ${pickThemeColor('LIGHT_PURPLE')};
  }
`;

export const StyledMessage = styled.div`
  color: ${pickThemeColor('BLACK_PRIMARY')};
  ${pickThemeFontStyles('16', '26', 'NORMAL')};
`;
